import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, ViewChild, TemplateRef, ViewContainerRef, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SseService } from 'src/app/services/SseService';
import { CustomizerSettingsService } from '../customizer-settings/customizer-settings.service';
import { RastreadorService } from 'src/app/services/rastreador.service';
import { Location } from '@angular/common';
import { concat, EMPTY, map, Observable, of, from, timer } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';
import { MetaApiService, MetaApiDownloadFase } from 'src/app/services/meta-api.service';
import { FmpIntradiaService } from 'src/app/services/fmp-intradia.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { LoginDialogComponent } from '../broker/login-dialog/login-dialog.component';
import { Overlay, OverlayRef, ConnectedPosition } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';

@Component({
  selector: 'app-crear-modelo',
  templateUrl: './crear-modelo.component.html',
  styleUrls: ['./crear-modelo.component.scss']
})
export class CrearModeloComponent implements OnInit, OnDestroy {
  readonly today: string = new Date().toISOString().split('T')[0];
  @Input() fechaInicial: string;
  @Input() fecharegistrosuscripcion: string;
  @Input() frecuencySelect: any[];
  @Input() selectedFrecuency: any;
  @Input() mercados: any[];
  @Input() selectedIdMercado: any;
  @Input() planificadorsv: any;
  @Input() companiasIndice: any[];
  @Input() companiasVolatilidad: any[];
  @Input() idMercadoIndice: any;
  @Input() idActivoIndice: any;
  @Input() idMercadovolatilidad: any;
  @Input() idActivoVolatilidad: any;
  @Input() bajista: boolean;
  @Input() periodico: boolean;
  @Input() todosSelected: boolean;
  @Input() Modelformdata: any;
  @Input() optimalWallet: any;
  @Input() asignarCapital: boolean;
  @Input() repeticionEntradas: boolean;
  @Input() editing: boolean;
  @Input() stopLoss: boolean;
  @Input() proFit: boolean;
  @Input() stopLossDinamico: boolean;
  @Input() stopLossValue: number;
  @Input() proFitValue: number;
  @Input() diasSalida: boolean;
  @Input() diasSalidaValue: number;
  @Input() salidaFinDia: boolean;
  @Input() isInValidModel: boolean;
  @Input() activatedModelo: boolean;
  @Input() earningsActive: boolean;
  /**
   * Modo screener: el panel se usa para buscar las companias que cumplen las condiciones en una
   * fecha, no para construir un modelo. Oculta lo que no interviene en esa busqueda (tipo de
   * estrategia, estrategia periodica y condiciones de salida) y el boton pasa a "Buscar".
   */
  @Input() screener: boolean = false;
  /** Solo deja elegir las listas MetaTrader de la cuenta con sesión iniciada (ver app-mercado-select). */
  @Input() restringirCuentaMetaapi: boolean = false;

  @ViewChild('periodicoPanel') periodicoPanel: TemplateRef<any>;
  @ViewChild('periodicoToggleAnchor', { read: ElementRef }) periodicoToggleAnchor: ElementRef;
  private periodicoOverlayRef: OverlayRef | null = null;

  get selectedMercadoIsMetaapi(): boolean {
    return this.mercados?.find((m: any) => m.idmercado === this.selectedIdMercado)?.metaapi ?? false;
  }

  public openBrokerLogin(): void {
    const account = this.metaApiService.getAccountId();
    const dialogRef = this.dialog.open(LoginDialogComponent, {
      width: '800px', height: '600px',
      data: { metaApi: true, soloLoginMetaApi: true, cuenta: account }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result?.accountId) {
        this.metaapiAccountId = result.accountId;
      }
    });
  }

  @Output() changeInputEvent = new EventEmitter<{ field: string, event: any }>();
  @Output() toggleIndiceEvent = new EventEmitter<void>();
  @Output() toggleVolatilidadEvent = new EventEmitter<void>();
  @Output() buscarCompaniaEvent = new EventEmitter<string>();
  @Output() registrarCompaniaEvent = new EventEmitter<{ type: string, event: any }>();
  @Output() onTodosChangeEvent = new EventEmitter<any>();
  @Output() actualizarcapitalinicialEvent = new EventEmitter<void>();
  @Output() startEditingEvent = new EventEmitter<any>();
  @Output() finishEditingEvent = new EventEmitter<any>();
  @Output() actualizarSlideStoplossEvent = new EventEmitter<any>();
  @Output() actualizarSlideProfitEvent = new EventEmitter<any>();
  @Output() actualizarSlideDiasSalidaEvent = new EventEmitter<any>();
  @Output() actualizarSlideStoplossDinamicoEvent = new EventEmitter<any>();
  @Output() actualizarSlideSalidaFinDiaEvent = new EventEmitter<any>();
  @Output() tipoEstrategiaChangeEvent = new EventEmitter<any>();
  @Output() generateModelEvent = new EventEmitter<void>();
  @Output() getFrecuencyEvent = new EventEmitter<any>();
  metaapiAccountId: string = '';
  isLoadingMetaapi: boolean = false;
  candlesDownloadBatch: number = 0;
  candlesDownloadTotal: number = 0;
  candlesDownloadExpected: number = 0;
  candlesDownloadSymbol: string = '';
  candlesDownloadFase: MetaApiDownloadFase | '' = '';
  /** Que proveedor esta descargando: cambia las etiquetas y la unidad del progreso. */
  descargaFuente: 'metaapi' | 'fmp' | '' = '';
  public metaapiConnected: boolean = false;

  public isModelsRoute: boolean = false;
  public showAddFilterMenu: boolean = false;
  public token: any;
  theme: string;
  diasemanaliteral: string = 'Lunes';
  private fechaInicialDefault: string = '';
  public fechaMinimaDisponible: string = '';
  constructor(    private metaApiService: MetaApiService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private location: Location, public _rastreadorservice: RastreadorService, private router: Router, private apisseservice: SseService, private _cookieService: CookieService, public themeService: CustomizerSettingsService,
    private overlay: Overlay, private viewContainerRef: ViewContainerRef,
    private fmpIntradiaService: FmpIntradiaService,
  ) { }

  ngOnDestroy() {
    this.closePeriodicoPanel();
    this.fmpIntradiaService.cerrar();
    // Invalida cualquier sincronizacion MetaApi en curso (ver metaapiSyncToken): sin esto, salir
    // de /models a mitad de una descarga no la para, solo deja de mostrar su progreso.
    this.metaapiSyncToken++;
  }

  openPeriodicoPanel() {
    if (!this.periodico || this.periodicoOverlayRef) return;

    const positions: ConnectedPosition[] = [
      { originX: 'end', originY: 'top', overlayX: 'start', overlayY: 'top', offsetX: 12 },
      { originX: 'start', originY: 'top', overlayX: 'end', overlayY: 'top', offsetX: -12 },
    ];
    const positionStrategy = this.overlay.position()
      .flexibleConnectedTo(this.periodicoToggleAnchor)
      .withPositions(positions)
      .withPush(true);

    this.periodicoOverlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
      hasBackdrop: false,
    });

    this.periodicoOverlayRef.attach(new TemplatePortal(this.periodicoPanel, this.viewContainerRef));
  }

  closePeriodicoPanel() {
    if (this.periodicoOverlayRef) {
      this.periodicoOverlayRef.dispose();
      this.periodicoOverlayRef = null;
    }
  }

  ngOnInit() {
    this.checkRoute();
    this.metaapiConnected = !!this.metaApiService.getToken();
    this.metaApiService.connected$.subscribe(val => { this.metaapiConnected = val; });
    const savedAccountId = localStorage.getItem('metaapi_account_id');
    if (savedAccountId) this.metaapiAccountId = savedAccountId;
    this.token = this._cookieService.get('auth_token');
    this.theme = localStorage.getItem('theme') || 'light-theme';
    this.fechaInicialDefault = this.Modelformdata?.fechaInicio || this.fechaInicial || '2010-01-01';
    this.fechaMinimaDisponible = this.fechaInicialDefault;

    // escuchar cambios en this.Modelformdata.idMercado
    this._rastreadorservice.idMercado$.subscribe((data: any) => {
      this.Modelformdata.idMercado = Number(data);
      console.log("Modelformdata: ", data);
    });
    this._rastreadorservice.valformdata$.subscribe((data: any) => {
      console.log("Datos recibidos en el componente:", data);
      this.Modelformdata = data;
    });
  }

  private checkRoute() {
    const currentUrl = this.router.url;
    console.log('Current URL:', currentUrl);
    this.isModelsRoute = currentUrl.includes('/models');
  }
actualizarSlideProfit(event: any) {
        this.actualizarSlideProfitEvent.emit(event);
    }
    actualizarSlideDiasSalida(event: any) {
        this.actualizarSlideDiasSalidaEvent.emit(event);
    }
    actualizarSlideSalidaFinDia(event: any) {
        this.actualizarSlideSalidaFinDiaEvent.emit(event);
    }
  // Bloquea la tecla ↑/↓ (flechas del teclado que incrementan/decrementan el segmento
  // día/mes/año enfocado en el <input type="date">) apenas el valor ya está en el límite,
  // para que el navegador ni siquiera llegue a aplicar el paso — así se evita cualquier
  // parpadeo o "giro" visible, en vez de corregirlo después de que ya se mostró.
  // fecharegistrosuscripcion llega como "YYYY-MM-DD HH:MI:SS.ffffff" (timestamp de Postgres);
  // se recorta a segundos para no mostrar milisegundos/microsegundos en el badge.
  get horaSuscripcionFormateada(): string {
    const hora = this.fecharegistrosuscripcion?.split(' ')?.[1];
    return hora ? hora.split('.')[0] : '';
  }

  onFechaKeydown(event: KeyboardEvent) {
    const el = event.target as HTMLInputElement;
    if (!el.value) return;
    if (event.key === 'ArrowUp' && el.max && el.value >= el.max) {
      event.preventDefault();
    } else if (event.key === 'ArrowDown' && el.min && el.value <= el.min) {
      event.preventDefault();
    }
  }

  // Red de seguridad: corrige el valor en cada tick del spinner nativo (evento `input`,
  // cubre también el mouse-wheel y los botoncitos del spinner, que no pasan por `keydown`),
  // clampeando contra el min/max propios del elemento — para que nunca llegue a verse un
  // valor fuera de rango ni por un instante. `change` recién corrige al perder foco.
  // Se clampea al min/max del propio DOM (no al valor previamente confirmado en el modelo)
  // para que, tras girar varios pasos válidos, quede clavado en el límite y no salte atrás
  // al valor que tenía el campo antes de empezar a editar.
  onFechaInput(event: any) {
    const el = event.target;
    const ainput = el?.value;
    if (!ainput) return;
    if (el.max && ainput > el.max) {
      el.value = el.max;
    } else if (el.min && ainput < el.min) {
      el.value = el.min;
    }
  }

  changeInput(field: string, event: any) {
    // El output (change) de app-mercado-select comparte nombre con el evento DOM 'change', que
    // burbujea desde el input de busqueda de ng-select: ese no trae un mercado, se descarta.
    if (field === 'idMercado' && event instanceof Event) { return; }
    this.changeInputEvent.emit({ field, event });

    if (field === "fechaInicio") {
      var ainput = event.target?.value || event?.value || event?.checked;
      if (ainput > this.today) {
        this.toastr.error('La fecha inicial no puede ser mayor a hoy');
        event.target.value = this.fechaInicial;
        return;
      }
      if (ainput < this.fechaMinimaDisponible) {
        this.toastr.error(`La fecha inicial no puede ser menor al primer dato disponible (${this.fechaMinimaDisponible})`);
        event.target.value = this.fechaInicial;
        return;
      }
      let obfecha = new Date(ainput);
      let dia = obfecha.getDate();
      let mes = obfecha.getMonth() + 1;
      let year = obfecha.getFullYear();
      ainput = `${year}-${mes.toString().padStart(2, '0')}-${dia.toString().padStart(2, '0')}`;
      this.Modelformdata.fechaInicio = ainput;
      this.diasemanaliteral = this.getDiaSemanalLiteral(obfecha);
    }

    if(field === "idMercado") {
      console.log(this.mercados);
      console.log("Valor seleccionado:", this.selectedIdMercado);
      let mercado = this.mercados.find((m: any) => m.idmercado === this.selectedIdMercado);
      console.log("Mercado seleccionado:", mercado);
      mercado.metaapi ? this.Modelformdata.margen = 1 : this.Modelformdata.margen = 30;
      // El intradia ya no es exclusivo de MetaApi: los mercados de FMP lo descargan por backend.
      if(mercado.metaapi){
        this.downloadMetaapiCandles(mercado);
      } else {
        this.downloadFmpIntradia(mercado);
      }
      this.checkAndUpdateFechaInicial();
    }

    if(field === "period") {
      const mercado = this.mercados?.find((m: any) => m.idmercado === this.selectedIdMercado);
      if(mercado?.metaapi) {
        this.downloadMetaapiCandles(mercado);
      } else if (mercado) {
        this.downloadFmpIntradia(mercado);
      }
      this.checkAndUpdateFechaInicial();
    }

    if (field === "periodico") {
      this.periodico ? this.openPeriodicoPanel() : this.closePeriodicoPanel();
    }
//    console.log(this.periodico);
  }
  private downloadOneTimeframeForCompany(
    compania: any,
    timeframe: string,
    accountId: string,
    licencia: string,
    skipSpec: boolean,
    onBatch?: (batch: number, total: number) => void,
    onTotal?: (expected: number) => void,
    onFase?: (fase: MetaApiDownloadFase) => void
  ): Observable<any> {
    const notifyFailure = (context: string) => (err: any) => {
      console.error(`[MetaAPI] ${context} (${compania.iso} ${timeframe})`, err);
      this.toastr.error(`Descarga incompleta de ${compania.iso} (${timeframe}). Se reintentará en la próxima sincronización.`, 'MetaAPI', { timeOut: 6000 });
      return EMPTY;
    };
    // Notifies the backend once MetaApi confirms it has no data before a given date, so future
    // syncs stop re-requesting the same empty range (see metaapi/historiaAgotada, metaapi/tieneCandles).
    const onExhausted = (fechaConfirmada: string) => {
      this.apisseservice.apiPostNew('metaapi/historiaAgotada', { idNectum: compania.idNectum, timeframe, fechaConfirmada }, licencia).subscribe({
        error: (err) => console.error(`[MetaAPI] Error marcando historia agotada (${compania.iso} ${timeframe})`, err)
      });
    };
    // Notifies the backend once a gap-fill pass finds nothing at the source for an internal
    // hole, so future syncs stop reporting/retrying that exact hueco.
    const onHuecoExhausted = (huecoInferior: string, huecoSuperior: string) => {
      this.apisseservice.apiPostNew('metaapi/huecoConfirmado', { idNectum: compania.idNectum, timeframe, huecoInferior, huecoSuperior }, licencia).subscribe({
        error: (err) => console.error(`[MetaAPI] Error marcando hueco confirmado (${compania.iso} ${timeframe})`, err)
      });
    };
    return this.apisseservice.apiPostNew('metaapi/tieneCandles', { idNectum: compania.idNectum, timeframe, accountId }, licencia).pipe(
      concatMap((res: any) => {
        if (res.tieneCandles) {
          // downloadMissingCandles resumes any pending gap (internal hole, incomplete
          // old-tail backfill, or the normal recent-tail gap) based on the extended
          // tieneCandles response — self-healing across interrupted downloads.
          return this.metaApiService.downloadMissingCandles(accountId, compania.iso, timeframe, res, onBatch, onTotal, onFase, onExhausted, onHuecoExhausted).pipe(
            concatMap((candles: any[]) => {
              if (!candles || candles.length === 0) return EMPTY;
              return this.apisseservice.apiPostNew('metaapi/candles', { candles, symbol: compania.iso, timeframe, idNectum: compania.idNectum }, licencia);
            }),
            catchError(notifyFailure('Error rellenando huecos de velas'))
          );
        }
        onFase?.('inicial');
        const fromDate = MetaApiService.historicalFromDate(timeframe);
        if (skipSpec) {
          return this.metaApiService.getCandlesHistorical(accountId, compania.iso, timeframe, fromDate, undefined, undefined, onBatch, onTotal, onExhausted).pipe(
            concatMap((batchCandles: any[]) => {
              if (!batchCandles || batchCandles.length === 0) return EMPTY;
              return this.apisseservice.apiPostNew('metaapi/candles', { candles: batchCandles, symbol: compania.iso, timeframe, idNectum: compania.idNectum }, licencia);
            }),
            catchError(notifyFailure('Error en descarga inicial de velas'))
          );
        }
        return this.metaApiService.getSymbolSpecification(accountId, compania.iso).pipe(
          concatMap((spec: any) => {
            if (!spec) return EMPTY;
            return from([
              this.metaApiService.getCandlesHistorical(accountId, compania.iso, timeframe, fromDate, undefined, undefined, onBatch, onTotal, onExhausted).pipe(
                concatMap((batchCandles: any[]) => {
                  if (!batchCandles || batchCandles.length === 0) return EMPTY;
                  return this.apisseservice.apiPostNew('metaapi/candles', { candles: batchCandles, symbol: compania.iso, timeframe, idNectum: compania.idNectum, contractSize: spec.contractSize }, licencia);
                }),
                catchError(notifyFailure('Error en descarga inicial de velas'))
              ),
              this.apisseservice.apiPostNew('metaapi/specificationes', { ...spec, tipoBroker: 'METAAPI' }, licencia).pipe(
                catchError(notifyFailure('Error guardando especificación de símbolo'))
              )
            ]).pipe(concatMap(obs$ => obs$));
          }),
          catchError(notifyFailure('Error obteniendo especificación de símbolo'))
        );
      }),
      catchError(notifyFailure('Error verificando estado de velas'))
    );
  }

  /**
   * @param periodo    periodo a descargar; por defecto el del combo de frecuencia.
   * @param alTerminar se llama al acabar la descarga, tambien si falla o si se cancela el login,
   *                   para quien necesita esperar las velas (p. ej. models al cargar por URL).
   */
  /**
   * Identifica la sincronizacion de velas MetaApi en curso. Se incrementa en cada llamada a
   * downloadMetaapiCandles, y las tres suscripciones anidadas (canDownloadCandles,
   * buscadorCompaniasPorMercado, el bucle por compania) comprueban el valor capturado al entrar
   * antes de seguir: si ya no coincide, la sincronizacion se abandono (cambio de periodo o de
   * mercado) y no tiene sentido continuar. No se usan Subscription porque las tres llamadas estan
   * anidadas dentro de callbacks `next`, no encadenadas con operadores, y unsubscribe() de la
   * exterior no habria cancelado las interiores.
   *
   * Sin esto, cada cambio de periodo/mercado lanzaba una descarga completa nueva para todas las
   * companias del mercado sin cancelar la anterior: con varios cambios seguidos se acumulaban
   * sincronizaciones enteras corriendo en paralelo, cada una pidiendo datos reales a MetaApi.
   */
  private metaapiSyncToken = 0;

  downloadMetaapiCandles(mercado: any, periodo?: number, alTerminar?: () => void): void {
    const miToken = ++this.metaapiSyncToken;
    const metaapiAccount = localStorage.getItem('metaapi_account_id') || '';
    // La cuenta pudo cambiar (aquí o en otra pestaña) con la lista ya seleccionada
    if (this.restringirCuentaMetaapi && mercado?.metaapi_account_id && metaapiAccount
        && mercado.metaapi_account_id !== metaapiAccount) {
      this.toastr.warning(`La lista ${mercado.iso} pertenece a otra cuenta MetaTrader. Inicia sesión con esa cuenta para usarla.`, 'Lista no disponible');
      alTerminar?.();
      return;
    }
    this.metaApiService.canDownloadCandles(metaapiAccount).subscribe({
      next: (guard) => {
        if (miToken !== this.metaapiSyncToken) return;
        if (!guard.ok) {
          this.metaapiConnected = false;
          this.toastr.error(guard.message, guard.title, { timeOut: 5000 });
          const dialogRef = this.dialog.open(LoginDialogComponent, {
            width: '800px',
            height: '600px',
            data: {
              metaApi: true,
              soloLoginMetaApi: true,
              cuenta: guard.accountId || metaapiAccount
            }
          });

          dialogRef.afterClosed().subscribe((result: any) => {
            if (miToken !== this.metaapiSyncToken || !result?.metaApiAuthenticated) {
              alTerminar?.();
              return;
            }

            if (result.accountId) {
              this.metaapiAccountId = result.accountId;
            }

            this.downloadMetaapiCandles(mercado, periodo, alTerminar);
          });
          return;
        }

        this.metaapiAccountId = guard.accountId;

        this.apisseservice.apiPostNew('buscadorCompaniasPorMercado', { idmercado: mercado.idmercado }, this.token).subscribe({
          next: (data: any) => {
            if (miToken !== this.metaapiSyncToken) return;
            if (this.metaApiService.avisarSiExcedeLimiteDescarga(data?.length ?? 0, mercado.iso)) {
              alTerminar?.();
              return;
            }
            this.descargaFuente = 'metaapi';
            this.isLoadingMetaapi = true;
            const periodoTimeframes: {[key: number]: string} = {1:'1m',2:'5m',3:'15m',4:'30m',5:'1h',6:'1d',7:'4h',8:'1w'};
            const timeframe = periodoTimeframes[Number(periodo ?? this.selectedFrecuency ?? this.Modelformdata?.period ?? 6)] ?? '1d';
            const licencia = this._cookieService.get('auth_token');
            const onBatch = (batch: number, total: number) => {
              this.candlesDownloadBatch = batch;
              this.candlesDownloadTotal = total;
            };
            const onTotal = (expected: number) => { this.candlesDownloadExpected = expected; };
            const onFase = (fase: MetaApiDownloadFase) => { this.candlesDownloadFase = fase; };
            from(data).pipe(
              concatMap((compania: any) => {
                if (miToken !== this.metaapiSyncToken) return EMPTY;
                this.candlesDownloadSymbol = compania.iso;
                this.candlesDownloadBatch = 0;
                this.candlesDownloadTotal = 0;
                this.candlesDownloadExpected = 0;
                this.candlesDownloadFase = '';
                return timer(100).pipe(
                  concatMap(() => concat(
                    this.downloadOneTimeframeForCompany(compania, timeframe, this.metaapiAccountId, licencia, false, onBatch, onTotal, onFase),
                    timeframe !== '1d'
                      ? this.downloadOneTimeframeForCompany(compania, '1d', this.metaapiAccountId, licencia, true, onBatch, onTotal, onFase)
                      : EMPTY
                  ))
                );
              })
            ).subscribe({
              complete: () => { this.isLoadingMetaapi = false; alTerminar?.(); },
              error:    () => { this.isLoadingMetaapi = false; alTerminar?.(); }
            });
          },
          error: (error) => {
            this.isLoadingMetaapi = false;
            console.error('[MetaAPI] Error al obtener compañías:', error);
            alTerminar?.();
          }
        });
      }
    });
  }

  /**
   * Dispara en el backend la descarga intradia de FMP para el mercado y periodo elegidos.
   *
   * Solo tiene sentido para periodos intradia: el diario ya lo cubre la descarga existente de
   * historical-price-full, que corre por su propia via.
   *
   * Con alTerminar (ver downloadMetaapiCandles) no se reajusta la fecha inicial al acabar: quien
   * lo pasa ya trae su propia fecha (p. ej. la de la suscripcion al cargar un modelo por URL).
   */
  downloadFmpIntradia(mercado: any, periodoParam?: number, alTerminar?: () => void): void {
    const periodo = Number(periodoParam ?? this.selectedFrecuency ?? this.Modelformdata?.period ?? 6);
    if (periodo === 6 || periodo === 8) { alTerminar?.(); return; }

    // La barra no se enciende aqui sino con el primer 'simbolo': el backend solo anuncia los
    // activos que descarga de verdad, y los que el cron de 1m ya tiene al dia no llegan a mostrarla.
    this.descargaFuente = 'fmp';
    this.candlesDownloadSymbol = '';
    this.candlesDownloadBatch = 0;
    this.candlesDownloadTotal = 0;
    this.candlesDownloadExpected = 0;
    this.candlesDownloadFase = 'inicial';

    this.fmpIntradiaService.descargar(mercado.idmercado, 0, periodo).subscribe({
      next: (ev) => {
        if (ev.tipo === 'total') {
          // El progreso de FMP se cuenta por activos, no por velas: el backend descarga
          // simbolo a simbolo y no sabe de antemano cuantas velas traera cada uno.
          this.candlesDownloadExpected = Number(ev.data) || 0;
        } else if (ev.tipo === 'simbolo') {
          this.isLoadingMetaapi = true;
          this.candlesDownloadSymbol = ev.data;
          this.candlesDownloadTotal++;
        } else if (ev.tipo === 'aviso') {
          console.warn('[FMP]', ev.data);
        }
      },
      complete: () => {
        this.isLoadingMetaapi = false;
        this.candlesDownloadFase = '';
        this.descargaFuente = '';
        if (alTerminar) {
          alTerminar();
        } else {
          this.checkAndUpdateFechaInicial();
        }
      },
      error: () => {
        this.isLoadingMetaapi = false;
        this.candlesDownloadFase = '';
        this.descargaFuente = '';
        alTerminar?.();
      }
    });
  }

  faseLabel(fase: MetaApiDownloadFase | ''): string {
    switch (fase) {
      case 'hueco': return 'rellenando hueco interno';
      case 'cola-antigua': return 'completando historial antiguo';
      case 'reciente': return 'actualizando datos recientes';
      case 'inicial': return 'descarga inicial';
      default: return '';
    }
  }

  getDiaSemanalLiteral(ainput: Date): string {
    return ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'][ainput.getDay()];
  }

  toggleIndice() {
    this.toggleIndiceEvent.emit();
  }

  toggleVolatilidad() {
    const wasEnabled = !!this.planificadorsv?.showVolatilidad;
    this.toggleVolatilidadEvent.emit();

    // Only preload defaults when the filter is being enabled.
    if (wasEnabled) {
      return;
    }

    console.log("idMercadovolatilidad: ", this.idMercadovolatilidad);
    if (this.idMercadovolatilidad == 0 || this.idMercadovolatilidad == undefined) {
      this.idMercadovolatilidad = 17;
      this.buscarCompania('Volatilidad');
    }
  }

  toggleAddFilterMenu() {
    this.showAddFilterMenu = !this.showAddFilterMenu;
  }

  addMarketFilter(tipo: 'Indice' | 'Volatilidad') {
    if (tipo === 'Indice' && !this.planificadorsv?.showIndice) {
      this.toggleIndice();
    }

    if (tipo === 'Volatilidad' && !this.planificadorsv?.showVolatilidad) {
      this.toggleVolatilidad();
    }

    this.showAddFilterMenu = false;
  }

  removeMarketFilter(tipo: 'Indice' | 'Volatilidad') {
    if (tipo === 'Indice' && this.planificadorsv?.showIndice) {
      this.toggleIndice();
    }

    if (tipo === 'Volatilidad' && this.planificadorsv?.showVolatilidad) {
      this.toggleVolatilidad();
    }
  }

  buscarCompania(tipo: string) {
    if (tipo == 'Indice') {
      const jsonData = {
        idmercado: this.idMercadoIndice
      };
      this.apisseservice.apiPostNew('listadecompaniaspormercado', jsonData, this.token).subscribe({
        next: (data: any) => {
          this.companiasIndice = data;
        }
      });
    } else if (tipo == 'Volatilidad') {
      const jsonData = {
        idmercado: this.idMercadovolatilidad
      };
      this.apisseservice.apiPostNew('listadecompaniaspormercado', jsonData, this.token).subscribe({
        next: (data: any) => {
          this.companiasVolatilidad = data;

          this.idActivoVolatilidad = 52920;
        }
      });
    }
  }

  nombreactivo(condicion: string): Observable<string> {
  console.log("condicion: ", condicion);
  
  if (condicion.includes(':')) {
    const partes = condicion.split(':');
    const idactivo = partes[0];
    
    if (!isNaN(Number(idactivo))) {
      const idactivoNum = Number(idactivo);
      const jsonData = { idNectum: idactivoNum };
      return this.apisseservice.apiPostNewSinToken('ia/obtenerNombreActivo', jsonData).pipe(
        map((data: any) => condicion.replace(idactivo, data.nombre))
      );
    }
  }
  
  return of(condicion);
}

  registrarCompania(input: string, event: any) {
    console.log("registrar" + this.idActivoIndice);
    console.log(event);
    if (input == 'IndiceActivo') {
      this.planificadorsv.idActivoIndice = this.idActivoIndice;
      console.log(this.planificadorsv.idActivoIndice);
    }
    if (input == 'VolatilidadActivo') {
      console.log(this.planificadorsv.idActivoVolatilidad);
      this.planificadorsv.idActivoVolatilidad = this.idActivoVolatilidad;
    }
  }

  onTodosChange(event: any) {
    this.onTodosChangeEvent.emit(event);
  }

  actualizarcapitalinicial() {
    this.actualizarcapitalinicialEvent.emit();
  }

  startEditing(item: any) {
    this.startEditingEvent.emit(item);
  }


  finishEditing(item: any) {
    this.finishEditingEvent.emit(item);
  }

  removeCondition(item: any) {
    if (this.location.path().includes('/models?')) {
      const keepAnalisis = this.location.path().includes('modo=analisis');
      this.location.replaceState(`/models`, keepAnalisis ? 'modo=analisis' : '');
    }
    // Por referencia: el item viene del *ngFor sobre condiciones, así dos condiciones con el
    // mismo texto no se confunden.
    const indice = this.planificadorsv.condiciones.indexOf(item);
    if (indice === -1) return;
    this.planificadorsv.condiciones.splice(indice, 1);
    this.planificadorsv.sincronizarListasCondiciones();
  }

  actualizarSlideStoploss(event: any) {
    this.actualizarSlideStoplossEvent.emit(event);
  }
  actualizarSlideStoplossDinamico(event: any) {
    this.actualizarSlideStoplossDinamicoEvent.emit(event);
  }
  onTipoEstrategiaChange(event: any) {
    this.tipoEstrategiaChangeEvent.emit(event);
  }

  generateModel() {
    if (this.selectedMercadoIsMetaapi && !this.metaapiConnected) {
      this.toastr.error('Se necesita conectarse al broker para usar datos MetaApi.');
      this.openBrokerLogin();
      return;
    }
    this.generateModelEvent.emit();
  }

  getFrecuency(event: any) {
    this.getFrecuencyEvent.emit(event);
  }

  private checkAndUpdateFechaInicial(): void {
    const idmercado = this.selectedIdMercado;
    const idperiodo = this.selectedFrecuency ?? this.Modelformdata?.period ?? 6;
    if (!idmercado) return;

    this.apisseservice.apiPostNew('primerFechaDisponible', { idmercado, idperiodo }, this.token).subscribe({
      next: (data: any) => {
        const primerDisponible = data?.fecha || this.fechaInicialDefault;
        this.fechaMinimaDisponible = primerDisponible;

        const nuevaFecha = (primerDisponible > this.fechaInicialDefault)
          ? primerDisponible
          : this.fechaInicialDefault;
        if (nuevaFecha !== (this.Modelformdata?.fechaInicio || this.fechaInicial)) {
          this.fechaInicial = nuevaFecha;
          this.Modelformdata.fechaInicio = nuevaFecha;
          this.changeInputEvent.emit({ field: 'fechaInicio', event: { target: { value: nuevaFecha } } });
          if (primerDisponible > this.fechaInicialDefault) {
            this.toastr.success(`Primer dato disponible: ${nuevaFecha}`, 'Fecha inicial actualizada', { timeOut: 4000 });
          }
        }
      },
      error: () => {}
    });
  }
}
